// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"79c47b46","295":"6cc73452","745":"a394f5d4","786":"2a983c7b","796":"c4988531","842":"7d5848b9"}[chunkId] + ".chunk.css";
};